import React, { HTMLAttributes } from 'react';
import './grid.less';

type Props = HTMLAttributes<HTMLDivElement>;

export function Grid({children, className, ...rest}: Props) {
    return (
        <div className={`biw-grid ${className || ''}`} {...rest}>
            {children}
        </div>
    );
}
